/**
 * Checks if a given date string represents a past date.
 *
 * @param dateStr - The date string to check
 * @returns true if the date is invalid, missing, or before today; false otherwise
 */
export const isPastDate = (dateStr?: string | null): boolean => {
    if (!dateStr) return true;

    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return true;

    const today = new Date();
    return date.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0);
};
